import moment, { Moment } from 'moment';

export const sanitizeText = (text?: string) => (text && text.trim() !== '' ? text : null);

export const sanitizeDate = (date?: string) => (date ? '"' + moment(date).format('YYYY-MM-DD') + '"' : null);

export const sanitizeArray = <T extends { id: number | string }>(array: T[]) =>
  array && array.length > 0
    ? JSON.stringify(
        array.map((p) => {
          return p.id;
        })
      )
    : null;

export const formatDate = (date: Moment | null) => (date ? date.format('YYYY-MM-DD') : null);
export const momentDate = (date: string | undefined | null) =>
  date && date.trim().length > 0 ? moment(date, 'YYYY-MM-DD') : null;
